import AddEditProjectForm from '@/modules/projects/add-projects';
import { useParams } from 'react-router-dom';
import { useGetProject } from '@/services/projects/queries';
import { Skeleton } from '@/components/ui/skeleton';
import PageContainer from '@/components/layout/page-container';

export default function EditProjectPage() {
  const { id } = useParams<{ id: string }>();
  
  const { data: project, isLoading } = useGetProject(id || '', {
    enabled: !!id,
    staleTime: 1000 * 60 * 2,
    refetchOnWindowFocus: false
  });

  if (isLoading) {
    return (
      <PageContainer>
        <div className='flex items-center justify-center h-[60vh]'>
          <Skeleton className='w-full h-full rounded-lg' />
        </div>
      </PageContainer>
    );
  }

  if (!project) {
    return (
      <PageContainer>
        <div className='text-center py-12'>
          <h2 className='text-xl font-semibold text-gray-900'>Project not found</h2>
          <p className='text-gray-600 mt-2'>The project you're looking for doesn't exist.</p>
        </div>
      </PageContainer>
    );
  }

  return (
    <PageContainer scrollable={true}>
      <div className='max-w-4xl rounded bg-white p-6'>
        <div className='space-y-6'>
          <AddEditProjectForm mode='edit' initialData={project} />
        </div>
      </div>
    </PageContainer>
  );
}
